import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import Slider from "react-slick";
import { getProductById } from "../services/product.service";
import { getCategoryById } from "../services/category.service";
import { useCart } from "../context/CartContext";

const ProductDetailsTwo = () => {
  const [product, setProduct] = useState(null);
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [quantity, setQuantity] = useState(1);
  const [mainImage, setMainImage] = useState("");
  const [categoryName, setCategoryName] = useState("VedhaCultures");
  const { addToCart, isInCart } = useCart();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("id");

  useEffect(() => {
    const fetchProductData = async () => {
      if (!productId) return;
      try {
        const productData = await getProductById(productId);
        if (productData) {
          setProduct(productData);
          setVariants(productData.variants || []);
          if (productData.imageUrls && productData.imageUrls.length > 0) {
            setMainImage(productData.imageUrls[0]);
          }
          if (productData.variants && productData.variants.length > 0) {
            setSelectedVariant(productData.variants[0]);
            // if (productData.variants[0].imageUrl) {
            //   setMainImage(productData.variants[0].imageUrl);
            // }
          }

          if (productData.categoryId) {
            const cat = await getCategoryById(productData.categoryId);
            if (cat) setCategoryName(cat.name);
          } else if (productData.categoryName) {
            setCategoryName(productData.categoryName);
          }
        }
      } catch (error) {
        console.error("Error fetching product details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProductData();
  }, [productId]);

  const incrementQuantity = () => {
    const maxStock = Number(selectedVariant ? (selectedVariant.stock ?? product.stock ?? 999) : (product.stock ?? 999));
    if (quantity < maxStock) {
      setQuantity(quantity + 1);
    }
  };
  const decrementQuantity = () =>
    setQuantity(quantity > 1 ? quantity - 1 : 1);

  const handleVariantSelect = (variant) => {
    setSelectedVariant(variant);
    setQuantity(1);
    if (variant.imageUrl) {
      setMainImage(variant.imageUrl);
    }
  };

  const settingsThumbs = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 424,
        settings: { slidesToShow: 3 },
      },
    ],
  };

  if (loading) return <div className="py-80 text-center"><div className="spinner-border text-main-600"></div></div>;
  if (!product) return <div className="py-80 text-center">Product not found.</div>;

  const currentPrice = selectedVariant ? selectedVariant.price : (product.price || 0);

  const allImages = [
    ...(product.imageUrls || []),
    // ...variants.map(v => v.imageUrl).filter(url => url && !product.imageUrls?.includes(url))
  ];

  return (
    <section className='product-details py-40 py-md-80'>
      <div className='container container-lg'>
        <div className='row gy-4'>
          {/* Main Content Area */}
          <div className='col-12 col-xl-9'>
            <div className='row gy-4'>
              {/* Image Gallery */}
              <div className='col-12 col-md-5'>
                <div className='product-details__left'>
                  <div className='product-details__thumb-slider border border-gray-100 rounded-16 bg-white overflow-hidden shadow-sm'>
                    <img
                      src={mainImage || "assets/images/thumbs/product-img1.png"}
                      alt={product.name}
                      className="product-details-main-img"
                    />
                  </div>
                  <div className='mt-16 mt-md-24'>
                    <div className='product-details__images-slider'>
                      {allImages.length > 1 && (
                        <Slider {...settingsThumbs}>
                          {allImages.map((image, index) => (
                            <div key={index} className="px-2 px-md-4">
                              <div
                                className={`h-100 flex-center border rounded-8 rounded-md-12 p-4 p-md-8 cursor-pointer transition-2 ${mainImage === image ? 'border-main-600 bg-main-50 shadow-sm' : 'border-gray-100 hover-border-main-600 bg-white'}`}
                                onClick={() => setMainImage(image)}
                              >
                                <img
                                  src={image}
                                  alt={`Thumbnail ${index}`}
                                  className="product-details-thumb-img"
                                />
                              </div>
                            </div>
                          ))}
                        </Slider>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className='col-12 col-md-7'>
                <div className='product-details__content'>
                  <div className="flex-align gap-8 mb-8 mb-md-12">
                    <span className="badge bg-main-600 text-white rounded-pill px-10 px-md-12 py-4 py-md-6 text-xs uppercase tracking-wider">{categoryName}</span>
                    {(selectedVariant?.sku || product.sku) && (
                      <span className="text-gray-400 text-xs text-md-sm">SKU: {selectedVariant?.sku || product.sku}</span>
                    )}
                  </div>

                  <h4 className='mb-12 mb-md-16 fw-bold text-gray-900 product-details-title'>{product.name}</h4>

                  <div className='flex-align flex-wrap gap-12 gap-md-16 mb-16 mb-md-24'>
                    <span className={selectedVariant?.stock > 0 || variants.some(v => v.stock > 0) ? 'text-success-600 fw-bold text-xs text-md-sm' : 'text-danger-600 fw-bold text-xs text-md-sm'}>
                      <i className={`ph-fill ${selectedVariant?.stock > 0 || variants.some(v => v.stock > 0) ? 'ph-check-circle' : 'ph-x-circle'} me-4`} />
                      {selectedVariant?.stock > 0 ? 'In Stock' : (selectedVariant ? 'Out of Stock' : (variants.some(v => v.stock > 0) ? 'In Stock' : 'Out of Stock'))}
                    </span>
                  </div>

                  <div className='my-20 my-md-32 p-16 p-md-24 bg-gray-50 rounded-12 rounded-md-16 border border-gray-100'>
                    <div className='flex-align gap-12 gap-md-16 flex-wrap'>
                      <h3 className='mb-0 text-main-600 fw-bold product-details-price'>Rs.{currentPrice}</h3>
                    </div>
                  </div>

                  <div className="product-description mb-24 mb-md-32">
                    <h6 className="mb-8 mb-md-12 fw-bold text-gray-900 product-details-section-title">Short Description</h6>
                    <div
                      className='text-gray-600 text-sm text-md-md lh-base lh-md-lg'
                      dangerouslySetInnerHTML={{ __html: product.shortDescription || "Experience the authentic quality and traditional craftsmanship of VedhaCultures." }}
                    />
                  </div>

                  {variants.length > 0 && (
                    <div className='mt-24 mt-md-32 pb-24 pb-md-32'>
                      <h6 className='mb-12 mb-md-16 text-gray-900 fw-bold product-details-section-title'>Available Options</h6>
                      <div className='flex-align gap-8 gap-md-12 flex-wrap'>
                        {variants.map((v) => (
                          <button
                            key={v.id}
                            onClick={() => handleVariantSelect(v)}
                            className={`px-14 px-md-20 py-8 py-md-12 text-xs text-md-sm rounded-8 rounded-md-12 border fw-bold transition-2 shadow-sm ${selectedVariant?.id === v.id
                              ? "border-main-600 text-main-600 bg-main-50 ring-1 ring-main-600"
                              : "border-gray-200 text-gray-700 bg-white hover-border-main-600 hover-bg-gray-50"
                              }`}
                          >
                            {v.value}
                            {v.price !== product.price && <span className="ms-4 ms-md-8 text-xs text-gray-400"> (Rs.{v.price})</span>}
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar - Cart Actions */}
          <div className='col-12 col-xl-3'>
            <div className='product-details__sidebar p-20 p-md-32 border border-gray-100 rounded-16 rounded-md-24 bg-white shadow-lg sticky-top product-details-sidebar-mobile'>
              <div className='mb-20 mb-md-32'>
                <label className='text-sm text-md-md mb-8 mb-md-12 text-gray-900 fw-bold d-block'>Quantity</label>
                <div className='flex-align d-inline-flex border border-gray-100 rounded-10 rounded-md-12 bg-white shadow-sm mb-20 mb-md-32 overflow-hidden'>
                  <button
                    onClick={decrementQuantity}
                    type='button'
                    className='h-40 h-md-48 w-40 w-md-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white transition-2'
                  >
                    <i className='ph ph-minus fw-bold' />
                  </button>
                  <input
                    type='number'
                    className='w-48 w-md-64 border-0 bg-transparent text-center fw-bold text-md text-lg-md'
                    style={{ outline: 'none' }}
                    value={quantity}
                    readOnly
                  />
                  <button
                    onClick={incrementQuantity}
                    type='button'
                    className='h-40 h-md-48 w-40 w-md-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white transition-2'
                  >
                    <i className='ph ph-plus fw-bold' />
                  </button>
                </div>
              </div>

              <div className='mb-20 mb-md-32 p-14 p-md-20 bg-gray-50 rounded-12 rounded-md-16 border border-gray-100'>
                <div className='flex-between mb-8'>
                  <span className='text-gray-500 text-xs text-md-sm'>Price per unit</span>
                  <span className='text-gray-900 fw-bold text-sm text-md-base'>Rs.{currentPrice}</span>
                </div>
                <div className='flex-between pt-10 pt-md-12 border-top border-gray-200'>
                  <span className='text-gray-900 fw-bold text-sm text-md-base'>Subtotal</span>
                  <h5 className='text-main-600 mb-0 fw-bold product-details-subtotal'>Rs.{currentPrice * quantity}</h5>
                </div>
              </div>

              {isInCart(product.id, selectedVariant?.id) ? (
                <Link
                  to='/cart'
                  className='btn bg-success-600 text-white d-flex justify-content-center align-items-center gap-8 gap-md-12 rounded-12 rounded-md-16 py-14 py-md-18 fw-bold w-100 hover-bg-success-700 shadow-main transition-2'
                >
                  <i className='ph ph-check-circle text-xl text-md-2xl' />
                  <span>Go to Cart</span>
                </Link>
              ) : (
                <button
                  onClick={() => {
                    if (selectedVariant?.stock > 0) {
                      addToCart(product, selectedVariant, quantity);
                    }
                  }}
                  disabled={!selectedVariant || selectedVariant.stock <= 0}
                  className={`btn ${!selectedVariant || selectedVariant.stock <= 0 ? 'bg-gray-400' : 'bg-main-600 hover-bg-main-700'} text-white d-flex justify-content-center align-items-center gap-8 gap-md-12 rounded-12 rounded-md-16 py-14 py-md-18 fw-bold w-100 shadow-main transition-2`}
                >
                  <i className={!selectedVariant || selectedVariant.stock <= 0 ? 'ph ph-prohibit text-xl text-md-2xl' : 'ph ph-shopping-cart text-xl text-md-2xl'} />
                  <span>{!selectedVariant || selectedVariant.stock <= 0 ? 'Out of Stock' : 'Add to Cart'}</span>
                </button>
              )}

              {selectedVariant?.stock > 0 && selectedVariant.stock < 10 && (
                <div className="mt-10 mt-md-12 text-center text-danger-600 text-xs text-md-sm fw-bold animate__animated animate__pulse animate__infinite">
                  Only {selectedVariant.stock} left in stock!
                </div>
              )}

              <style>{`
                .product-details__sidebar {
                    display: flex !important;
                    flex-direction: column !important;
                    align-items: stretch !important;
                }
                .product-details .btn {
                    width: 100% !important;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;
                }
              `}</style>
            </div>
          </div>
        </div>

        {product.longDescription && (
          <div className="mt-40 mt-md-80 pt-40 pt-md-80 border-top border-gray-100">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">
                <h4 className="mb-20 mb-md-32 fw-bold text-gray-900 text-center product-details-long-title">Product Details</h4>
                <div
                  className="long-description text-gray-600 text-sm text-md-md lh-base lh-md-lg"
                  dangerouslySetInnerHTML={{ __html: product.longDescription }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductDetailsTwo;
